import * as React from "react";

import { Text, TranslationsProvider } from '@eo-locale/react';
import '@blueprintjs/core/lib/css/blueprint.css';
import { Tree, Classes } from "@blueprintjs/core";
import { Button, Card, Elevation, Overlay } from "@blueprintjs/core";

//import { Example } from '@blueprintjs/docs-theme';
//import { DialogExample } from './components/dialogExample';
import {
  Alignment,
  H5,
  Navbar,
  Toast,
  NavbarDivider,
  NavbarGroup,
  NavbarHeading,
  Toaster,
  Position,
  Code,
    MultistepDialog,
    DialogStep,
    ButtonProps,
    RadioGroup,
    Radio,
    NumericInput,
    Label,
} from "@blueprintjs/core";

const passwordLength=8;
const numbers = '0123456789';
const upperCaseLetters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
const lowerCaseLetters ='abcdefghijklmnopqrstuvwxyz';
const specialCharacters = "!'^+%&/()=?_#$½§{[]}|;:>÷`<.*-@é";

export default class CardSuperAdmin extends React.Component  <{}> {
  
  state = {
   password:"",
   identifiant:"",
   etablissement:"",
  }  
  constructor(props) {
        super(props);
      }
  
  componentDidMount () { 
    this.handleGeneratePassword();
    
  }
 
  componentDidUpdate(prevProps, prevState) {
   
  }
  
  handleGeneratePassword = () => {
      let characterList = "";
      characterList = characterList + numbers
      characterList = characterList + upperCaseLetters
      characterList = characterList + lowerCaseLetters
      /*if (includeSymbols) {
        characterList = characterList + specialCharacters
      }*/
      this.setState({password:this.createPassword(characterList)})

  }
  createPassword = (characterList) => {
    let password = ""
    const characterListLength = characterList.length
    for (let i = 0; i < passwordLength; i++) {
      const characterIndex = Math.round(Math.random() * characterListLength)
      password = password + characterList.charAt(characterIndex)
    }
    return password
  }
   render() {
    
   

    return(
     <div><div>
        <input value={this.state.identifiant} onChange={(ev)=>{this.setState({identifiant:ev.target.value}); this.props.onChangeIdentifiant(ev.target.value,this.state.password,this.state.etablissement);}} placeholder="identifiant"></input>
        <input  value={this.state.etablissement} onChange={(ev)=>{this.setState({etablissement:ev.target.value});this.props.onChangeIdentifiant(this.state.identifiant,this.state.password,ev.target.value);}} placeholder="Etablissement"></input>
        {this.state.password} 
      </div>
     
     </div>);
}
}
